const FooterDisclaimer = () => {
  return (
    <p>
      Information on this site is general in nature and does not constitute
      financial, legal or tax advice. For specific details about products
      offered by Creditstar Group subsidiaries, please refer to the respective
      websites via which the services are provided.
    </p>
  )
}

export default FooterDisclaimer
